<template>
  <div class="updates-tab">
    <template v-if="updates.length === 0 && !isAddFormOpened && updatesLoaded">
      <div class="empty-timeline-message">
        <template v-if="isMy">
          <div class="text_large">{{ i18n.sale_tab_updates_ismy_header() }}</div>
          <div class="text_small text_margin text_description">{{ i18n.sale_tab_updates_ismy_text() }}</div>
          <md-button class="btn md-primary"
                     v-if="isMy"
                     @click="openForm">{{ i18n.sale_add_note_bt() }}</md-button>
        </template>
        <div class="text_large" v-else>{{i18n.sale_upd_tab_important_updated()}}</div>
      </div>
    </template>
    <add-update-form v-if="isAddFormOpened && updatesLoaded"
                      class="updates-tab__add-form"
                      :sale="sale"
                      @close="closeForm"
                      @timeline-add-finished="getUpdates"
    />
    <timeline v-if="!isAddFormOpened && updates.length > 0 && updatesLoaded"
              @timeline-add-click="openForm"
              class="updates-tab__timeline"
              :items="updates"
              :sale="sale"
    />

  </div>
</template>

<script>
  import Timeline from '../components/UpdatesTab.Timeline'
  import AddUpdateForm from '../components/UpdatesTab.Timeline.AddForm'

  import { blobTypes, blobFilters } from '@const'
  import { usersService } from '@api/users.service'
  import { i18n } from '@js/i18n'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  export default {
    name: 'updates-tab',

    components: {
      Timeline,
      AddUpdateForm
    },
    props: ['sale'],
    data: _ => ({
      isAddFormOpened: false,
      updates: [],
      updatesLoaded: false,
      i18n
    }),
    computed: {
      ...mapGetters([
        vuexTypes.accountId
      ]),
      isMy () {
        return this.sale.owner === this.accountId
      }
    },
    methods: {
      async getUpdates () {
        if (!this.sale || !this.sale.id) return
        this.updates = await usersService
          .blobsOf(this.sale.owner)
          .getAll({
            [blobFilters.fundID]: this.sale.id,
            [blobFilters.type]: blobTypes.fundUpdate.num
          })
        this.updatesLoaded = true
      },
      openForm () {
        this.isAddFormOpened = true
      },
      closeForm () {
        this.isAddFormOpened = false
      }
    },
    watch: {
      sale: {
        handler: 'getUpdates',
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/variables";

  /*.updates-tab__no-updates-msg,
  .updates-tab__add-form {
    margin: auto;
    padding-bottom: 30px;
  }

 !* .empty-timeline-message {
    display: flex;
    flex-direction: column;
    text-align: center;
    background: linear-gradient(0deg, rgba(203, 226, 230, 0.1), rgba(203, 226, 230, 0.1)), #FFFFFF;
    border: 1px dashed rgba(203, 226, 230, 0.8);
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5% 15%;
    * {
      margin: 10px 0;
    }
    button {
      margin-bottom: 2em;
    }
  }*!

  .updates-tab__add-item-btn {
    margin: 2rem auto 0;
  }*/
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/tabs/Sales.UpdatesTab.vue